import { ProjectDTO,ProjectDTONameAndId } from 'models'
import { OnSelectCallbackParam } from 'react-daterange-picker'
import { PaginationProps, SortDirection } from 'utilities'

export type UserProjects = { [key: string]: ProjectDTONameAndId[] }

export enum UsersTableSortProps {
  NAME = 'name',
  ROLE = 'roles',
  ADDED_ON = 'created',
  ADDED_BY = 'createdBy'
}

export type UsersTableSearchProps = {
  name: string
  role: number
  projects: string
  addedOnPeriod: OnSelectCallbackParam
  addedBy: string
}

export const initialUsersTableSearchProps: UsersTableSearchProps = {
  name: '',
  role: null,
  projects: '',
  addedOnPeriod: null,
  addedBy: ''
}

export const initialUsersTablePaginationProps: PaginationProps<
  UsersTableSortProps
> = {
  page: 0,
  size: 15,
  sortDirection: SortDirection.ASC,
  sortProp: UsersTableSortProps.NAME,
  totalElements: 0,
  totalPages: 0
}

export const usersTableNeedTimeoutProps: Array<
  keyof UsersTableSearchProps
> = ['name', 'projects', 'addedBy']
